import {
    ChangeDetectionStrategy,
    Component,
    WritableSignal,
    signal,
} from '@angular/core';

import { PresenterType } from '@shared/components';
import { AuthReauthenticationRequiredMessage } from './auth-reauthentication-required.message';

@PresenterType({
    model: AuthReauthenticationRequiredMessage,
})
@Component({
    selector: 'auth-reauthentication-required-message-template',
    templateUrl: './auth-reauthentication-required-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AuthReauthenticationRequiredMessageTemplateComponent {
    public data: WritableSignal<AuthReauthenticationRequiredMessage>;

    constructor() {
        this.data = signal<AuthReauthenticationRequiredMessage>(null);
    }
}